(function($) {

	$.fn.msxiicon = function(options) {
		// build main options before element iteration
		var opts = $.extend( {}, $.fn.msxiicon.defaults, options);

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend( {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend( {}, eOpts, $this.dataset()) : eOpts;

            if($this.hasClass('icon-only'))
            {
                eOpts['icon-only'] = true;
            }
            if(eOpts['icon'].indexOf('msxi') > -1)
            {
                eOpts['icon-msxi-class'] = 'ui-icon-msxi';
            }

            if(eOpts['icon-only']) {
                /*if(!$this.attr('title') || $this.attr('title').length==0)
                {
                    $this.attr('title', $this.text());
                }*/
                $this.empty();
            }
            else {
                $this.wrapInner($('<span />').addClass('ui-icon-text'));
            }
            if(eOpts['icon']) {
                $($('<span />').addClass('ui-icon'))
                .addClass("ui-icon-primary").addClass(eOpts['icon']).addClass(eOpts['icon-msxi-class'])
                .appendTo($this.addClass('ui-icon-container-primary'));
            }
            if(eOpts['icon-secondary']) {
                $($('<span />').addClass('ui-icon'))
                .addClass("ui-icon-secondary").addClass(eOpts['icon-secondary'])
                .appendTo($this.addClass('ui-icon-container-secondary'));
            }
            if(eOpts['icon-overlay']) {
                $($('<span />').addClass('ui-icon'))
                .addClass("ui-icon-overlay").addClass(eOpts['icon-overlay'])
                .appendTo($this.addClass('ui-icon-container-overlay'));
            }
        });
	};
	//
	// plugin defaults
	//
	$.fn.msxiicon.defaults = {
         icon: '',
        'icon-secondary': '',
        'icon-only': false,
        'icon-msxi-class': ''
	};

})(jQuery);